import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import _ from 'lodash'
import ogImage from "../../images/posts/44/thumb-landscape.jpg"

import Slider from "react-slick";

const Post44 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,

    responsive: [
    {
      breakpoint: 1024,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
    {
      breakpoint: 599,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      }
    }
  ]    
  };

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">GUCCI／GGマーモント／24 x13 x7cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>“ダブルG”がフロントを飾るGUCCI（グッチ）の人気バッグGG マーモント（GG MARMONT）ライン。<br></br>2016年の登場から瞬く間に人気となりアイコンバッグとなりました。ダブルGのエンブレムが特徴的なバッグですが、こちらはGUCCI（グッチ）のアーカイブコードのひとつで1970年代にGUCCI（グッチ）が手掛けていたベルトのバッグルをモチーフにしています。クリエイティブ・ディレクターのアレッサンドロ・ミケーレの手によって、ヴィンテージライクな雰囲気は残しつつ新たにアップデートされたGG マーモント（GG MARMONT）ラインはコーディネートに取り入れやすいシンプルで大人っぽいデザインが魅力です。<br></br>今回は、特におすすめのシェイプ、コーディネートを紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.〔GGマーモント〕キルティング スモール ショルダーバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.〔GGマーモント〕キルティング ミニバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.〔GGマーモント〕キルティング スモール ショルダーバッグ キルティング ミニバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.〔GGマーモント〕スモール トップハンドルバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.〔GGマーモント〕ミニ トップハンドルバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>6.〔GGマーモント〕キルティング2wayバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80}>7.まとめ</ScrollLink>             
        </p>
      </div>               
      <div name="sec1" className="text-max-width">
        <h2>1.〔GGマーモント〕キルティング スモール ショルダーバッグ /24x14x7cm(幅x高さxマチ)</h2>
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/1.jpg" alt="GUCCI（グッチ）のアイコンバッグ　GG マーモント（GG MARMONT）"/>
        </figure>        
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/2.jpg" alt="GUCCI（グッチ）のアイコンバッグ　GG マーモント（GG MARMONT）"/>
        </figure>
      </div>
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/44/3.jpg"/>
        <StaticImage src="../../images/posts/44/4.jpg"/>
        <StaticImage src="../../images/posts/44/5.jpg"/>
        <StaticImage src="../../images/posts/44/6.jpg"/>
        <StaticImage src="../../images/posts/44/7.jpg"/>
        <StaticImage src="../../images/posts/44/8.jpg"/>
        <StaticImage src="../../images/posts/44/9.jpg"/>
      </Slider>
      <p className="text-max-width">
        キルティングレザーで、スモールサイズのチェーンショルダーバッグ。数あるGGマーモントシリーズの中でも人気の高いタイプです！豊富なカラー展開も魅力のひとつです。
      </p>
      <figure>
        <StaticImage src="../../images/posts/44/10.jpg"/>
      </figure>  
      <p className="text-max-width">
        コンパクトな見た目ですが、長財布もしっかり収納可能です！
      </p> 
      <div name="sec2" className="text-max-width">
        <h2>2.〔GGマーモント〕キルティング ミニバッグ /17x11x6cm(幅x高さxマチ)</h2>      
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/44/11.jpg"/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/44/12.jpg"/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/44/13.jpg"/>
      </figure>
      <p className="text-max-width">
        スモールをひと回り小さくしたミニバッグ。スマホと小さめウォレットの収納が可能で、休日のお出かけバッグとしても人気です。
      </p>
      <figure>
        <StaticImage src="../../images/posts/44/14.jpg"/>
      </figure>
      <p className="text-max-width">サイズ感で悩んでしまう方も多いので、比較してみました。圧倒的人気はスモールですが、マスクでのお出かけが多い今、ミニサイズで気軽にお出かけも良いですね♡<br></br>右：スモール　左；ミニ
      </p>
      <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
       GUCCIのバッグを見る
      </Link>         
      <div name="sec3" className="text-max-width">
        <h2>3.〔GGマーモント〕キルティング スモール ショルダーバッグ /24x15x7cm(幅x高さxマチ)</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/44/15.jpg"/>
      </figure>  
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/16.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/17.jpg"/>
        </figure>        
      </div>
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/44/18.jpg"/>
        <StaticImage src="../../images/posts/44/19.jpg"/>
        <StaticImage src="../../images/posts/44/20.jpg"/>
        <StaticImage src="../../images/posts/44/21.jpg"/>
      </Slider> 
      <p className="text-max-width">
        オーバーサイズのフラップ クロージャータイプ。ストラップは、スライドチェーン式なので、カジュアルな気分の時はストラップを長くしてショルダーバッグとして、またエレガントな装いの時はハンドバッグとしても◎。同タイプでひと回り小さい〔GGマーモント〕キルティング ミニバッグ/21x13x5cm(幅x高さxマチ)もあります。
      </p>
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/44/22.jpg"/>
        <StaticImage src="../../images/posts/44/23.jpg"/>
        <StaticImage src="../../images/posts/44/24.jpg"/>
        <StaticImage src="../../images/posts/44/25.jpg"/>
      </Slider>
      <div name="sec4" className="text-max-width">
        <h2>4.〔GGマーモント〕スモール トップハンドルバッグ /26x17x11cm(幅x高さxマチ)</h2>      
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/26.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/27.jpg"/>
        </figure>        
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/44/28.jpg"/>
      </figure> 
      <p className="text-max-width">
        トップハンドルが付いており、2WAYでの使用が可能！チェーンストラップは取り外しができます。全く異なる雰囲気となりおすすめです！バッグ背面にはハートがあしらわれてます♡
      </p>
      <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
       GUCCIのバッグを見る
      </Link>        
      <div name="sec5" className="text-max-width">
        <h2>5.〔GGマーモント〕ミニ トップハンドルバッグ /20x13x8cm(幅x高さxマチ)</h2>      
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/29.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/30.jpg"/>
        </figure>        
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/31.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/32.jpg"/>
        </figure>        
      </div>
      <p className="text-max-width">
        ミニは小さめでころんとしたシルエットでかわいい♡フラップ部分はスプリング クロージャー付きです。
      </p>
      <div name="sec6" className="text-max-width">
        <h2>6.〔GGマーモント〕キルティング2wayバッグ /26x19x12cm(幅x高さxマチ)</h2>      
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/33.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/44/34.jpg"/>
        </figure>        
      </div>
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/44/35.jpg"/>
        <StaticImage src="../../images/posts/44/36.jpg"/>
        <StaticImage src="../../images/posts/44/37.jpg"/>
      </Slider> 
      <p className="text-max-width">たっぷり収納可能で、通勤やお仕事バッグとしても活躍しそう。コンパートメント部分にはジップ付きで使いやすい♡
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/44/38.png"/>
      </figure>
      <p className="text-center">
        通勤コーデとしても◎
      </p>                                                                          
      <div name="sec7" className="text-two-cloumn">
        <h2>7.まとめ</h2>
        <p>
          いかがでしたでしょうか？<br></br>GG マーモント（GG MARMONT）シリーズはこの他にもたくさんの種類があります。オンにもオフにも使いやすく人気です！さまざまなシーンやコーデに合わせて取り入れてみてはいかがでしょうか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
       GUCCIのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post44

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 44}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
